import Vue from "vue"
import VueRouter from "vue-router"
import store from '@/store/index.js';
import { shouldRedirectToMobile, shouldRedirectToPC, getLoginRouteName } from '@/common/deviceUtils'

Vue.use(VueRouter)


// 防止路由重复点击报错，
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// 创建路由页面，
const routes = [
  {
    //客户端主页框架
    path: '/',
    name: 'Main',
    component: () => import('@/views/main/Main'),
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Dashboard'),
      },
      {
        path: '/BigScreen',
        name: 'BigScreen',
        component: () => import('@/views/bigscreen/BigScreenList'),
      },
      {
        path: '/BigScreen/:id',
        name: 'BigScreenDetail',
        component: () => import('@/views/bigscreen/BigScreenDetail'),
      },

      {
        path: '/UserReport',
        name: 'UserReport',
        component: () => import('@/views/userreport/UserReport'),
      },
      {
        path: '/UserReportView/:reportid',
        name: 'UserReportView',
        component: () => import('@/views/userreport/UserReportView'),
      },
      {
        path: '/SqbActivate',
        name: 'SqbActivate',
        component: () => import('@/views/setsys/SqbActivate'),
      }
    ]
  },
  {
    //智能登录页面（自动识别设备类型）
    path: '/login',
    name: 'login',
    meta:{notoken:true},
    component: () => import('@/views/login/SmartLogin'),
  },
  {
    //错误页面
    path: '/error',
    name: 'error',
    meta:{notoken:true},
    component: () => import('@/views/error/Error'),
  },
  {
    //打印页面
    path: '/Print',
    name: 'Print',
    component: () => import('@/views/print/Print'),
  },
  {
    //微信公众号登录授权页
    path: '/MobileBinding',
    name: 'MobileBinding',
    meta:{notoken:true},
    component: () => import('@/views/wx_mobilebinding/MobileBinding'),
  },
  {
    //移动端数据查看页面（提醒推送等）
    path: '/DataView/:id?',
    name: 'DataView',
    meta:{notoken:true},
    component: () => import('@/views/wx_mobilebinding/DataView'),
  },
  {
    // 移动端统一支付页（orderpay 节点 pageDisplayFields）
    path: '/PayView/:id?',
    name: 'PayView',
    meta: { notoken: true },
    component: () => import('@/views/wx_mobilebinding/PayView'),
  },
        {
        //移动端表单页面
        path: '/MobileForm',
        name: 'MobileForm',
        meta:{notoken:true},
        component: () => import('@/views/mobile/MobileForm'),
      },
      {
        //移动端登录页面
        path: '/MobileLogin',
        name: 'MobileLogin',
        meta:{notoken:true},
        component: () => import('@/views/mobile/MobileLogin'),
      },


 
  {
    //e5核心框架页面
    path: '/Ecore',
    name: 'Ecore',
    component: () => import('@/views/e_core/Core'),
    redirect: '/EoreHome',
    children: [
      {
        path: '/EoreHome',
        name: 'EoreHome',
        component: () => import('@/views/e_home/EoreHome'),
      },
      {
        path: '/EoreMenu/:id',
        name: 'EoreMenu',
        component: () => import('@/views/e_menu/EoreMenu'),
      },
      {
        path: '/EorePrint/:id',
        name: 'EorePrint',
        component: () => import('@/views/e_print/EorePrint'),
      },
      {
        path: '/EoreForm/:formname?',
        name: 'EoreForm',
        component: () => import('@/views/e_form/EoreForm'),
      },
      {
        path: '/EoreFormEdit',
        name: 'EoreFormEdit',
        component: () => import('@/views/e_formedit/EoreFormEdit'),
      },
      {
        path: '/EoreFormEvent',
        name: 'EoreFormEvent',
        component: () => import('@/views/e_formevent/EoreFormEvent'),
      },
      {
        path: '/EoreDeliver',
        name: 'EoreDeliver',
        component: () => import('@/views/e_deliver/EoreDeliver'),
      },
      {
        path: '/EoreReport/addreport',
        name: 'EoreReportAdd',
        component: () => import('@/views/e_report/EoreReport'),
      },
      {
        path: '/EoreReport/:reportid?',
        name: 'EoreReport',
        component: () => import('@/views/e_report/EoreReport'),
      },
      {
        path: '/EoreReportView/:reportid',
        name: 'EoreReportView',
        component: () => import('@/views/e_report/EoreReportView'),
      },
      {
        path: '/EoreReminder/addreminder',
        name: 'EoreReminderAdd',
        component: () => import('@/views/e_reminder/EoreReminder'),
      },
      {
        path: '/EoreReminder/:reminderid?',
        name: 'EoreReminder',
        component: () => import('@/views/e_reminder/EoreReminder'),
      }
    ]
  }

]

const router = new VueRouter({
  mode: 'history',
  routes
})

//登录导航守卫
router.beforeEach((to, from, next) => {
  try {
    // 每次导航都同步一次本地 token 到 store，确保刷新/清缓存后状态正确
    store.commit('getToken')
    const token = store.state.user.token  
    //判断拦截，避免刷新后导致动态路由消失，空白页面的情况
    if(to.name==null&&store.state.tab.menu.length<=0)
    {
      next({name: 'login'})//进行了守卫菜单
      return
    }
    
    // 已登录但访问登录页面：优先回到 redirect
    if (token && to.name === 'login') {
      if (to.query && to.query.redirect) { 
        next(to.query.redirect)
      } else {
        next({name: 'dashboard'})
      }
      return
    }
    
    // 已登录但访问移动端登录页面：优先回到 redirect
    if (token && to.name === 'MobileLogin') {
      if (to.query && to.query.redirect) { 
        next(to.query.redirect)
      } else if (from.name === 'MobileForm') {
        next()
      } else {
        next({name: 'dashboard'})
      }
      return
    }
    
    // 未登录且需要登录验证的页面
    if (!token && !to.meta.notoken) {
      // 未登录，跳转到对应设备类型的登录页面，并带上重定向地址（使用replace防止后退回受保护页）
      const loginRouteName = getLoginRouteName() 
      router.replace({ name: loginRouteName, query: { redirect: to.fullPath } })
      return
    }
    
    // 其他情况，正常跳转
    next()
    
  } catch (error) {
    console.error('路由守卫错误:', error)
    // 如果出现错误，直接跳转到登录页
    next({name: 'login'})
  }
})


// 导出路由
export default router
